import * as mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'
import 'url-search-params-polyfill'
import * as PATHS from 'src/router/paths'
import * as MODES from 'src/config/modes'
import AnalyticsService from '@/services/AnalyticsService'

// URL PARAMS
let urlParams = new window.URLSearchParams(window.location.search)

// DEBUG
let debug = process.env.NODE_ENV !== 'production'
// debug = false
if (urlParams.get('_debug') !== null) debug = true
if (urlParams.get('_debug') === 'false') debug = false

// VCONSOLE
let vconsole = process.env.NODE_ENV !== 'production'
vconsole = false
if (urlParams.get('_vconsole') !== null) vconsole = true
if (urlParams.get('_vconsole') === 'false') vconsole = false



// STATE
const state = {
  // version: pack.version,
  debug: debug,
  vconsole: vconsole,

  // VERSION
  version: {
    build: 0,
    date: null,
  },

  // LOADING
  loading: {
    progress: 0,
    completed: false,
  },

  // ROUTE
  route: {
    afterLoad: PATHS.LOADING, // default page to show after loading
    curr: {
      parent: null,
      child: null,
    },
    prev: {
      parent: null,
      child: null,
    },
  },

  loadAframe: false,
  loadScene: false,
  loadSceneProgress: 0,
  camZoom: 1,
  camDistort: 0,
  // UI
  tapped: false,
  muted: false,
  showSubtitles: true,
  showMenu: false,
  showGallery: false,
  showQRPage: false,
  showDestInfo: true,
  gallery: [],
  mode: MODES.ADULTS,

  sceneProgress: 0,
  mapProgress: 0,

  sceneEntered: false,
  sceneComplete: false,

  currSceneIdx: 0,

  modeSwitching: false,

  modeLock: true,

  bgm: null,


  tutorProgress: 0,
  tutorTouchX: 0.5,
  tutorTouchY: 1,

}

// EXPORT
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
